<template>
  <CommonList
    selection-type="radio"
    row-key="id"
    :has-more-search="false"
    :auto-load="true"
    ref="listRef"
    cell-overflow="ellipsis"
    @selection-change="handleSelectionChange"
    @current-row-change="handleCurrentRowChange"
    @load-start="handleLoadList"
    @search-click="handleLoadList"
    @pagination-change="handleLoadList"
    @reset-click="handleReset"
  >
    <template #search-item-fixed>
      <div class="common-search-item">
        <label class="common-search-label80">记录编号:</label>
        <el-input v-model="searchForm.recordId" class="common-input150" placeholder="请输入"></el-input>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">手机号:</label>
        <el-input v-model="searchForm.userPhone" class="common-input150" placeholder="请输入"></el-input>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">物品编号:</label>
        <el-input v-model="searchForm.itemId" class="common-input150" placeholder="请输入"></el-input>
      </div>
      <div class="common-search-item">
        <label class="common-search-label80">状态:</label>
        <el-select v-model="searchForm.status" class="common-input120" placeholder="请选择" clearable>
          <el-option label="待处理" value="0"></el-option>
          <el-option label="已发货" value="1"></el-option>
          <el-option label="已完成" value="2"></el-option>
        </el-select>
      </div>
    </template>

    <template #btn-group>
      <el-button
        type="warning"
        class="list-btn"
        @click="handleEdit"
        :disabled="!listShow"
      >
        <el-icon><Edit/></el-icon>
        修改
      </el-button>
    </template>

    <template #table-column>
      <el-table-column prop="recordId" label="记录编号" align="center" width="200"></el-table-column>
      <el-table-column prop="userName" label="兑换人" align="center" width="100"></el-table-column>
      <el-table-column prop="userPhone" label="手机号" align="center" width="120"></el-table-column>
      <el-table-column prop="itemId" label="物品编号" align="center" width="200"></el-table-column>
      <el-table-column prop="itemName" label="物品名称" align="center" min-width="120"></el-table-column>
      <el-table-column prop="requiredPoints" label="消耗积分" align="center" width="100"></el-table-column>
      <el-table-column prop="expressSupport" label="快递" align="center" width="80">
        <template #default="scope">
          <el-tag :type="scope.row.expressSupport === '1' ? 'success' : 'info'">
            {{ scope.row.expressSupport === '1' ? '是' : '否' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" align="center" width="100">
        <template #default="scope">
          <el-tag :type="getStatusType(scope.row.status)">
            {{ getStatusName(scope.row.status) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="兑换时间" align="center" width="180">
        <template #default="scope">
          {{ $formatTime(scope.row.createTime) }}
        </template>
      </el-table-column>
    </template>

    <template #extra>
      <el-dialog
        v-model="dialogVisible"
        title="修改兑换记录"
        width="720px"
        destroy-on-close
        class="record-dialog"
      >
        <el-form
          ref="formRef"
          :model="formData"
          label-width="100px"
          class="record-form"
        >
          <!-- 兑换信息（只读） -->
          <div class="form-section">
            <div class="section-title">
              <el-icon><InfoFilled/></el-icon>
              <span>兑换信息</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="记录编号">
                  <el-input v-model="formData.recordId" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="兑换人">
                  <el-input v-model="formData.userName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="手机号">
                  <el-input v-model="formData.userPhone" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物品编号">
                  <el-input v-model="formData.itemId" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物品名称">
                  <el-input v-model="formData.itemName" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="物品价值">
                  <el-input v-model="formData.itemValue" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="消耗积分">
                  <el-input v-model="formData.requiredPoints" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 收件信息（可编辑） -->
          <div class="form-section">
            <div class="section-title">
              <el-icon><Box/></el-icon>
              <span>收件信息</span>
              <el-tag :type="formData.expressSupport === '1' ? 'success' : 'info'" size="small" class="express-tag">
                {{ formData.expressSupport === '1' ? '需快递' : '无需快递' }}
              </el-tag>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="收件人">
                  <el-input v-model="formData.receiverName" placeholder="请输入收件人"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收件电话">
                  <el-input v-model="formData.receiverPhone" placeholder="请输入收件电话" maxlength="11"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="收件地址">
                  <el-input
                    v-model="formData.receiverAddress"
                    type="textarea"
                    :rows="2"
                    placeholder="请输入收件地址"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 处理信息（可编辑） -->
          <div class="form-section">
            <div class="section-title">
              <el-icon><EditPen/></el-icon>
              <span>处理信息</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="兑换状态">
                  <el-select v-model="formData.status" placeholder="请选择" style="width: 100%;">
                    <el-option label="待处理" value="0"></el-option>
                    <el-option label="已发货" value="1"></el-option>
                    <el-option label="已完成" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input
                    v-model="formData.remark"
                    type="textarea"
                    :rows="3"
                    placeholder="请输入备注"
                    maxlength="300"
                    show-word-limit
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
        <template #footer>
          <div style="text-align: center; width: 100%;">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="handleSubmit">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </template>
  </CommonList>
</template>

<script setup>
import useExchangeRecordList from './ExchangeRecordList.js';
import { InfoFilled, Box, EditPen } from '@element-plus/icons-vue';

const {
  searchForm,
  listRef,
  dialogVisible,
  formRef,
  listShow,
  formData,
  Edit,
  handleSelectionChange,
  handleCurrentRowChange,
  handleEdit,
  handleLoadList,
  handleReset,
  handleSubmit
} = useExchangeRecordList();

const getStatusType = (status) => {
  const map = { '0': 'warning', '1': 'primary', '2': 'success' };
  return map[status] || 'info';
};

const getStatusName = (status) => {
  const map = { '0': '待处理', '1': '已发货', '2': '已完成' };
  return map[status] || '未知';
};
</script>

<style>
@import '../../../assets/css/util/base-list.css';

.record-dialog .el-dialog__body {
  padding: 10px 20px;
}

.record-form .form-section {
  margin-bottom: 8px;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
}

.record-form .section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background-color: #f5f7fa;
  font-size: 14px;
  font-weight: 500;
  color: #303133;
  border-bottom: 1px solid #ebeef5;
}

.record-form .section-title .el-icon {
  color: #409eff;
  font-size: 16px;
}

.record-form .express-tag {
  margin-left: 8px;
}

.record-form .el-form-item {
  margin-bottom: 14px;
}

.record-form .el-row {
  padding: 16px 16px 0;
}

.record-dialog .el-dialog__footer {
  padding: 10px 20px 20px;
}
</style>
